import React, {Component} from 'react'

import {
  Card,
  CardContent,
  CardHeader,
  Typography,
} from 'material-ui'

export default class IDNotFound extends Component{
  render(){
    return (
      <Card className='card'>
        <CardHeader
          title={document.title}
        />
        <CardContent>
          <Typography align="center" color="inherit" type="title">
            Welcome to {document.title} {this.props.user ? this.props.user.displayName : null}
          </Typography>
          <Typography align="left" color="inherit" type="body1">
            Welcome to {document.title}.
          </Typography>
        </CardContent>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/IDNotFound.js